import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { memo, useCallback } from "react";
// import { createIndividual, updateIndividualById, getIndividualById } from "../../../../../services/individual.service";
import { TIndividualForm, individualSchema } from "./individualSchema";
import { AutoComplete, FormContainer, Treturn } from "@4uhub/lib4uhub";
import { age, individualItems, sex } from "../individual.mock";

interface IIndividualProps {
  id?: string;
  onBackButton: () => void;
}

const translationPath = "page.4uDlist.generationRule.individual.";

export const Individual = memo(({ id, onBackButton }: IIndividualProps) => {
  const { t } = useTranslation();

  //   const { sendRequest: save, loading: sLoading } = useFetch(
  //     createIndividual
  //   );

  //   const { sendRequest: update, loading: uLoading } = useFetch(
  //     updateIndividualById
  //   );

  //   const { sendRequest: get, loading: gLoading } = useFetch(
  //     getIndividualById
  //   );

  const saveHandler = async (v: TIndividualForm) => {
    // save({
    //   ...v,
    // });
    return { data: {}, success: true };
  };

  const updateHandler = async (v: TIndividualForm, id: string) => {
    // update({
    //   item: {
    //     ...v,
    //   },
    //   id: id,
    // });
    return { data: {}, success: true };
  };

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TIndividualForm>> => {
      //   const { data, success } = await get(id);
      //   if (data && success) {
      //     const newData: TIndividualForm = {
      //       ...data,
      //     };
      //     return { data: newData, success: true };
      //   }

      //   return { data, success };

      const data = individualItems.find((item) => item.id === id);
      if (data) {
        return { data, success: true };
      }

      return { data: null, success: false };
    },
    [],
  );

  const successHandle = () => {
    onBackButton();
  };

  //   const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TIndividualForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      //   loading={loading}
      title={t(translationPath + "individual")}
      schema={individualSchema}
      subtitle={t(translationPath + "new_individual")}
      backButtonOnClick={onBackButton}
      redirectOnSave={false}
      onSuccess={successHandle}
      isModalForm={true}
      propId={id}
      formActionsOnBottom={false}
      fields={() => (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <AutoComplete
              name="sex"
              size="small"
              options={sex}
              label={t(translationPath + "sex")}
              getOptionLabel={(option) => option.name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AutoComplete
              name="age"
              size="small"
              options={age}
              label={t(translationPath + "age")}
              getOptionLabel={(option) => option.name}
            />
          </Grid>
        </Grid>
      )}
    />
  );
});
